// [file name]: AddKindergarten.jsx
// [file content begin]
import React, { useState} from 'react';
import { Link } from 'react-router-dom';
import { config } from '../../data/config';
import { kindergartenAPI } from './actions';
import { validation } from './validation';

const AddKindergarten = () => {
  // Состояния компонента
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    edrpou: "",
    property: "",
    specialization: "",
    specifics: config.specificsKindergarten[0],
    type: "",
    description: "",
    contacts: {
      address: {
        string: "",
        district: config.districts[0],
        lat: undefined,
        lon: undefined
      },
      phones: [],
      site: "",
      email: ""
    },
    existence: undefined,
    workingHours: {
      type: config.workingHoursType[0],
      timeFrom: "",
      timeTo: "",
      daysOfWeek: ["Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця"],
      workAtHolidays: false
    },
    head: {
      firstName: "",
      lastName: undefined,
      code: undefined
    }
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Обработчики изменений полей
  const handleInputChange = (path, value) => {
    setFormData(prev => {
      const keys = path.split('.');
      const newData = { ...prev };
      let current = newData;

      for (let i = 0; i < keys.length - 1; i++) {
        current[keys[i]] = { ...current[keys[i]] };
        current = current[keys[i]];
      }

      current[keys[keys.length - 1]] = value;
      return newData;
    });
  };

  const handleArrayChange = (path, value, separator = ',') => {
    handleInputChange(path, value.split(separator).map(item => item.trim()));
  };

  const handleBooleanChange = (path, value) => {
    handleInputChange(path, value.match(/Так/i) ? true : false);
  };

  // Отправка формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    // Проверка обязательных полей
    const requiredFields = [
      'name', 
      'number', 
      'edrpou', 
      'contacts.address.lat', 
      'contacts.address.lon'
    ];

    if (!validation.chkFields(requiredFields, formData)) {
      setError("Не заповнені всі обов'язкові поля");
      return;
    }

    // Валидация email
    if (!validation.validateEmail(formData.contacts.email)) {
      setError("Некоректний email");
      return;
    }

    // Валидация ЕДРПОУ
    if (!validation.validateEdrpou(formData.edrpou)) {
      setError("Некоректний ЄДРПОУ. Має бути 8 цифр.");
      return;
    }

    // Валидация номера садика
    if (!validation.validateNumber(formData.number)) {
      setError("Некоректний номер садка. Дозволені тільки цифри та літери.");
      return;
    }

    // Валидация координат
    if (!validation.validateCoordinates(formData.contacts.address.lat, formData.contacts.address.lon)) {
      setError("Некоректні координати. Широта має бути від -90 до 90, довгота від -180 до 180.");
      return;
    }

    setLoading(true);

    try {
      const result = await kindergartenAPI.addKindergarten(formData);
      
      if (result.success) {
        setMessage(`ДНЗ № ${formData.number} додан.`);
        // Сброс формы
        setFormData({
          ...formData,
          name: "", number: "", edrpou: "", property: "", specialization: "",
          type: "", description: "", contacts: { ...formData.contacts, 
            address: { ...formData.contacts.address, string: "", lat: undefined, lon: undefined },
            phones: [], site: "", email: ""
          },
          workingHours: { ...formData.workingHours, timeFrom: "", timeTo: "" },
          head: { ...formData.head, firstName: "" }
        });
      } else {
        setError(`Помилка: ${result.error.message}`);
      }
    } catch (err) {
      setError(`Помилка сервера: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Основной контент */}
      <div className="container-fluid">
        <div className="container">
          <div className="row p-4 rounded">
            <div className="col-md-12">
              
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {message && (
                <div className="alert alert-success" role="alert">
                  {message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                {/* Блок номера садика и ЕДРПОУ */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <h5>Ідентифікаційні дані</h5>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">Номер закладу *</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.number}
                      onChange={(e) => handleInputChange('number', e.target.value)}
                      required
                      placeholder="Тільки цифри та літери"
                    />
                    <div className="form-text">Введіть номер закладу (тільки цифри та літери)</div>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">ЄДРПОУ *</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.edrpou}
                      onChange={(e) => handleInputChange('edrpou', e.target.value)}
                      required
                      placeholder="8 цифр"
                      maxLength="8"
                    />
                    <div className="form-text">Введіть 8-значний код ЄДРПОУ</div>
                  </div>
                </div>

                {/* Основная информация */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <h5>Основна інформація</h5>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">Назва *</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Власність</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.property}
                      onChange={(e) => handleInputChange('property', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Спеціалізація</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.specialization}
                      onChange={(e) => handleInputChange('specialization', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">Вид закладу *</label>
                  <div className="col-md-4">
                    <select
                      className="form-select"
                      value={formData.specifics}
                      onChange={(e) => handleInputChange('specifics', e.target.value)}
                    >
                      {config.specificsKindergarten.map((item, index) => (
                        <option key={index} value={item}>{item}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Тип</label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.type}
                      onChange={(e) => handleInputChange('type', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-start">
                  <label className="col-md-3 col-form-label">Опис</label>
                  <div className="col-md-6">
                    <textarea
                      className="form-control"
                      rows="4"
                      value={formData.description}
                      onChange={(e) => handleInputChange('description', e.target.value)}
                    />
                  </div>
                </div>

                {/* Контактная информация */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <h5>Контактна інформація</h5>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">Район *</label>
                  <div className="col-md-3">
                    <select
                      className="form-select"
                      value={formData.contacts.address.district}
                      onChange={(e) => handleInputChange('contacts.address.district', e.target.value)}
                    >
                      {config.districts.map((item, index) => (
                        <option key={index} value={item}>{item}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Адреса</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.contacts.address.string}
                      onChange={(e) => handleInputChange('contacts.address.string', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Телефон</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Телефони через ;"
                      onChange={(e) => handleArrayChange('contacts.phones', e.target.value, ';')}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Сайт</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.contacts.site}
                      onChange={(e) => handleInputChange('contacts.site', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Email</label>
                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      value={formData.contacts.email}
                      onChange={(e) => handleInputChange('contacts.email', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">Координати, широта * (dd.dddddd)</label>
                  <div className="col-md-3">
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      value={formData.contacts.address.lat || ''}
                      onChange={(e) => handleInputChange('contacts.address.lat', parseFloat(e.target.value))}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label fw-bold">Координати, довгота * (dd.dddddd)</label>
                  <div className="col-md-3">
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      value={formData.contacts.address.lon || ''}
                      onChange={(e) => handleInputChange('contacts.address.lon', parseFloat(e.target.value))}
                      required
                    />
                  </div>
                </div>

                {/* Время работы */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <h5>Час роботи</h5>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Тип робочого часу</label>
                  <div className="col-md-3">
                    <select
                      className="form-select"
                      value={formData.workingHours.type}
                      onChange={(e) => handleInputChange('workingHours.type', e.target.value)}
                    >
                      {config.workingHoursType.map((item, index) => (
                        <option key={index} value={item}>{item}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Початок (гг:хх)</label>
                  <div className="col-md-3">
                    <input
                      type="time"
                      className="form-control"
                      value={formData.workingHours.timeFrom}
                      onChange={(e) => handleInputChange('workingHours.timeFrom', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Завершення (гг:хх)</label>
                  <div className="col-md-3">
                    <input
                      type="time"
                      className="form-control"
                      value={formData.workingHours.timeTo}
                      onChange={(e) => handleInputChange('workingHours.timeTo', e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Робочі дні</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={formData.workingHours.daysOfWeek.join(', ')}
                      onChange={(e) => handleArrayChange('workingHours.daysOfWeek', e.target.value, ',')}
                    />
                  </div>
                </div>

                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Чи працює в свята</label>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder='Введіть "Так" або "Ні"'
                      onChange={(e) => handleBooleanChange('workingHours.workAtHolidays', e.target.value)}
                    />
                  </div>
                </div>

                {/* Руководитель */}
                <div className="row mb-3 align-items-center">
                  <label className="col-md-3 col-form-label">Керівник</label>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={formData.head.firstName}
                      onChange={(e) => handleInputChange('head.firstName', e.target.value)}
                    />
                  </div>
                </div>

                {/* Кнопка отправки */}
                <div className="row mb-3">
                  <div className="col-md-3"></div>
                  <div className="col-md-4">
                    <button 
                      type="submit" 
                      className="btn btn-primary px-4"
                      disabled={loading}
                    >
                      {loading ? 'Завантаження...' : 'Додати'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .form-control, .form-select {
          min-height: 38px;
        }
        .col-form-label {
          padding-top: 8px;
          padding-bottom: 8px;
        }
      `}</style>
    </div>
  );
};

export default AddKindergarten;
// [file content end]